var F = Object.defineProperty, G = Object.defineProperties;
var H = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, b = Object.prototype.propertyIsEnumerable;
var w = (r, s, p) => s in r ? F(r, s, { enumerable: !0, configurable: !0, writable: !0, value: p }) : r[s] = p, t = (r, s) => {
  for (var p in s || (s = {}))
    A.call(s, p) && w(r, p, s[p]);
  if (o)
    for (var p of o(s))
      b.call(s, p) && w(r, p, s[p]);
  return r;
}, f = (r, s) => G(r, H(s));
var h = (r, s) => {
  var p = {};
  for (var e in r)
    A.call(r, e) && s.indexOf(e) < 0 && (p[e] = r[e]);
  if (r != null && o)
    for (var e of o(r))
      s.indexOf(e) < 0 && b.call(r, e) && (p[e] = r[e]);
  return p;
};
import "react";
import "react/jsx-runtime";
import { u as J, e as K } from "./factory-ueRxoNOV.js";
function U(r, s, p) {
  const e = J(r, s, p), m = e, {
    label: v,
    description: x,
    error: l,
    required: P,
    classNames: i,
    styles: a,
    className: N,
    unstyled: n,
    __staticSelector: c,
    __stylesApiProps: u,
    errorProps: S,
    labelProps: k,
    descriptionProps: q,
    wrapperProps: z,
    id: _,
    size: y,
    style: C,
    inputContainer: I,
    inputWrapperOrder: O,
    withAsterisk: W,
    variant: d,
    vars: L,
    mod: g
  } = m, j = h(m, [
    "label",
    "description",
    "error",
    "required",
    "classNames",
    "styles",
    "className",
    "unstyled",
    "__staticSelector",
    "__stylesApiProps",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "wrapperProps",
    "id",
    "size",
    "style",
    "inputContainer",
    "inputWrapperOrder",
    "withAsterisk",
    "variant",
    "vars",
    "mod"
  ]), { styleProps: B, rest: D } = K(j), E = t({
    label: v,
    description: x,
    error: l,
    required: P,
    classNames: i,
    className: N,
    __staticSelector: c,
    __stylesApiProps: u || e,
    errorProps: S,
    labelProps: k,
    descriptionProps: q,
    unstyled: n,
    styles: a,
    size: y,
    style: C,
    inputContainer: I,
    inputWrapperOrder: O,
    withAsterisk: W,
    variant: d,
    id: _,
    mod: g
  }, z);
  return f(t({}, D), {
    classNames: i,
    styles: a,
    unstyled: n,
    wrapperProps: t(t({}, E), B),
    inputProps: {
      required: P,
      classNames: i,
      styles: a,
      unstyled: n,
      size: y,
      __staticSelector: c,
      __stylesApiProps: u || e,
      error: l,
      variant: d,
      id: _
    }
  });
}
export {
  U as u
};
